var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.608,
    height: 42.608,
    viewBox: "0 0 42.608 42.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_69",
    "data-name": "Grupo 69",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1064",
    "data-name": "Trazado 1064",
    d: "M1450.3-728.06a20.3,20.3,0,0,1-20.3,20.3,20.3,20.3,0,0,1-20.3-20.3,20.3,20.3,0,0,1,20.3-20.3A20.3,20.3,0,0,1,1450.3-728.06Z",
    transform: "translate(-1409.692 748.364)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1065",
    "data-name": "Trazado 1065",
    d: "M1501.058-626.362a13.246,13.246,0,0,0,7.174,2.1,13.239,13.239,0,0,0,13.3-13.924,9.485,9.485,0,0,0,2.335-2.423,9.348,9.348,0,0,1-2.688.737,4.685,4.685,0,0,0,2.057-2.589,9.373,9.373,0,0,1-2.972,1.137,4.673,4.673,0,0,0-3.417-1.478,4.685,4.685,0,0,0-4.559,5.748,13.284,13.284,0,0,1-9.647-4.891,4.686,4.686,0,0,0,1.449,6.25,4.661,4.661,0,0,1-2.121-.586,4.686,4.686,0,0,0,3.755,4.649,4.682,4.682,0,0,1-2.113.08,4.681,4.681,0,0,0,4.371,3.25A9.4,9.4,0,0,1,1501.058-626.362Z",
    transform: "translate(-1490.645 654.831)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9810c5ad4c3872ad9ead506ff9b835ab.svg";
export { ForwardRef as ReactComponent };